// extracted by mini-css-extract-plugin
export default {"none":"YwyvK92ws7"};